<template>
    <div class="filters">
        <v-select
            class="filters__select"
            v-model="filters.visibility"
            :options="visibilityOptions"
            :placeholder="$t('VISIBILITY')"
            clearable
        />

        <v-input
            class="filters__input"
            v-model="filters.name"
            :placeholder="$t('NAME')"
            :debounce="500"
            clearable
        />
    </div>
</template>

<script>
import { clone } from 'lodash';
import VSelect from '@/components/VSelect.vue';
import VInput from '@/components/VInput.vue';

export default {
  props: {
    value: Object,
  },
  components: {
    VSelect,
    VInput,
  },
  data() {
    return {
      filters: {
        visibility: null,
        name: '',
      },
    };
  },
  computed: {
    visibilityOptions() {
      return [
        {
          label: this.$t('PUBLIC'),
          value: 'public',
        },
        {
          label: this.$t('PRIVATE'),
          value: 'private',
        },
      ];
    },
  },
  watch: {
    filters: {
      handler() {
        this.$emit('input', clone(this.filters));
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.filters {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    &__input,
    &__select {
        width: 170px;

        @include tablet {
          width: auto;
          flex: 1 0 0;
        }
    }
}
</style>
